import * as React from 'react'
import { useAutoAnimate } from '@formkit/auto-animate/react'
import useLayoutStore from '../../../stores/useLayoutStore/useLayoutStore'
import { IconButton } from '../../common/IconButton/IconButton'
import classnames from 'classnames'
import { SidebarFooterLogo } from '../SidebarFooterLogo/SidebarFooterLogo'
import SidebarLegacyLink from '../SidebarLegacyLink/SidebarLegacyLink'

type SidebarProps = React.PropsWithChildren

export const Sidebar: React.FC<SidebarProps> = ({ children }) => {
    const [parent] = useAutoAnimate()
    const isSidebarCollapsed = useLayoutStore(
        (state) => state.isSidebarCollapsed
    )
    const { toggleSidebar } = useLayoutStore()

    const iconButtonClassname = classnames('transition-all', {
        'translate-x-[-20px]': isSidebarCollapsed,
    })

    const className = classnames('h-full', {
        'is-collapsed': isSidebarCollapsed,
    })

    const sidebarFooterClassName = classnames(
        'items-stretched mt-auto flex flex-col justify-between py-2 pl-2 pr-2 transition-all',
        {
            'gap-10': isSidebarCollapsed,
            'gap-3': !isSidebarCollapsed,
        }
    )

    return (
        <div className={className} ref={parent}>
            <div className="grid h-full grid-rows-[auto_1fr]">
                <div>{children}</div>
                <div
                    data-testid="sidebar-footer"
                    className={sidebarFooterClassName}
                >
                    <div className="flex items-center justify-center overflow-hidden px-2">
                        <SidebarLegacyLink isCollapsed={isSidebarCollapsed} />
                    </div>

                    <div className="relative flex flex-1 justify-between pl-5">
                        <SidebarFooterLogo isCollapsed={isSidebarCollapsed} />
                        <IconButton
                            className={iconButtonClassname}
                            name="toggleSidebarButton"
                            onClick={toggleSidebar}
                            variant="ghostSecondary"
                            icon={
                                isSidebarCollapsed
                                    ? 'chevron_right'
                                    : 'chevron_left'
                            }
                            size="medium"
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
